import { RestrictionsFormData } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { RestrictionItem } from 'src/common/OrderRestrictions/orderRestrictions.utils';

export function getRestrictionSubheader({
  restrictions,
  restrictionFormSelections,
}: GetRestrictionsHeader): string {
  const selectedKeys = extractSelectedRestrictionsKeys(
    restrictionFormSelections
  );

  if (selectedKeys.length === 0) {
    return 'Not required: no restrictions selected';
  }

  const displayNames = mapSelectedKeysToDisplayNames(
    selectedKeys,
    restrictions
  );

  return formatResultString(displayNames);
}

interface GetRestrictionsHeader {
  restrictions: RestrictionItem[];
  restrictionFormSelections: RestrictionsFormData;
}

function extractSelectedRestrictionsKeys(
  restrictionFormSelections: RestrictionsFormData
): string[] {
  if (!restrictionFormSelections) {
    return [];
  }

  return Object.keys(restrictionFormSelections).filter(
    (key) => restrictionFormSelections[key]
  );
}

function mapSelectedKeysToDisplayNames(
  selectedKeys: string[],
  restrictions: RestrictionItem[]
): string[] {
  if (!restrictions) {
    return selectedKeys;
  }

  const selectedKeysSet = new Set(selectedKeys);
  return restrictions
    .filter((restriction) => selectedKeysSet.has(restriction.type))
    .map((restriction) => restriction.displayName);
}

function formatResultString(displayNames: string[]): string {
  const result = displayNames.join(', ').toLowerCase();
  return result.charAt(0).toUpperCase() + result.slice(1);
}
